var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pointes-list"
  }, [_vm._l(_vm.pointLogs, function (item) {
    return _c('PointCard', {
      key: item.id,
      attrs: {
        "item": item,
        "isRedeemed": ""
      }
    });
  }), _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }